import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

import { CurrentTheme, MagstimDropdown } from "common";
import MagstimInputGroup from './MagstimInputGroup'

class MagstimInputGroupMultiDropDown extends MagstimInputGroup {

    constructor() {
        super();

        this._dropdowns = null;
    }

    onCheckboxChange = () => {
        const newCheckState = !this.state.checked;
        this.setState({ checked: newCheckState, disabled: !newCheckState })

        if (this.props.onSetEnabled !== undefined) {
            this.props.onSetEnabled(this.props.name, newCheckState);
        }
    }

    getKey = (index) => {
        return this._dropdowns[index].current.getKey();
    }

    getValue = (index) => {
        return this._dropdowns[index].current.getValue();
    }

    getProperty = () => {
        return this.props.property;
    }

    getChecked = () => {
        return this.state.checked;
    }

    render() {

        var titleClassName = "input-group-highlight"

        if (this.state.disabled === true) {
            titleClassName = "input-group-disabled"
        }

        // Create the item refs if needed
        if(this._dropdowns === null){
            this._dropdowns = [];

            for (var i = 0; i < this.props.options.length; i++) {
                this._dropdowns.push(React.createRef());
            }
        }

        // We don't handle the number od dropdowns changing or bad data, so just assert
        console.assert(this.props.options.length === this.props.defaults.length)
        console.assert(this.props.options.length === this._dropdowns.length)

        // Build the elements
        var dropdownElements = [];
        
        for (var j = 0; j < this.props.options.length; j++) {

            const defaultValue = this.props.defaults[j];
            var dropdownElement = <> <MagstimDropdown size={CurrentTheme().ControlSize} ref={this._dropdowns[j]} disabled={this.state.disabled}>
                                        {this.props.options[j].map(option => (
                                            this.dropdownItem(option, defaultValue)
                                        ))}
                                    </MagstimDropdown>
                                    <div className="mr-3"></div></>

            dropdownElements.push(dropdownElement);
        }

        // Render
        return (
            <>
                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
                    </InputGroupAddon>
                    <InputGroupAddon addonType="append" className="magstim-checkbox-container mr-3">
                        <Input type="checkbox" className="magstim-checkbox" checked={this.state.checked} onChange={this.onCheckboxChange} />
                    </InputGroupAddon>
                    {dropdownElements}
                </InputGroup>
            </>
        );
    }
}

MagstimInputGroupMultiDropDown.propTypes = {
    title: PropTypes.string,
    property:PropTypes.string,
    options: PropTypes.array,
    defaults: PropTypes.array,
    dropDownRef: PropTypes.object,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onSetEnabled: PropTypes.func
};

MagstimInputGroupMultiDropDown.defaultProps = {
    title: "",
    property: "",
    options: [],
    defaults: [],
    dropDownRef: undefined,
    disabled: false,
    checked: undefined,
    onSetEnabled: undefined
};

export default MagstimInputGroupMultiDropDown